import { Box } from "@mui/material";
import { TabButton } from "Components/UI/TabButton";
import { TabContainer } from "Components/UI/TabContainer";
import { enumToArray } from "Helpers/enumToText";
import { useSelectedProject } from "Hooks";
import { ChannelsPage } from "Pages/Train/ChannelsPage";
import SourcCategoriesPage from "Pages/Train/SourcCategoriesPage";
import TrafficAuditPage from "Pages/Train/TrafficAuditPage";
import TrafficBucketPage from "Pages/Train/TrafficBucketPage";
import { TrafficBucketsPage } from "Pages/Train/TrafficBucketsPage";
import TrafficConsolidatePage from "Pages/Train/TrafficConsolidatePage";
import { useCallback } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";

enum Tab {
  channel = "Channels",
  audit = "Traffic Audit",
  categories = "Source Categories",
  buckets = "Traffic Buckets",
  consolidate = "Traffic Consolidate",
}

function TrafficPage() {
  const { selectedProject } = useSelectedProject();
  const history = useHistory();
  const location = useLocation();

  const onTabChange = useCallback(
    (value: Tab) => {
      const baseURL = `/clients/${selectedProject?.clientId}/projects/${selectedProject?.id}/train/traffic/`;
      switch (value) {
        case Tab.channel:
          history.push(baseURL + "channels");
          break;
        case Tab.categories:
          history.push(baseURL + "source-categories");
          break;
        case Tab.buckets:
          history.push(baseURL + "buckets");
          break;
        case Tab.consolidate:
          history.push(baseURL + "consolidate");
          break;
        case Tab.audit:
          history.push(baseURL + "audit");
          break;

        default:
          break;
      }
    },
    [history, selectedProject]
  );

  const isActive = useCallback(
    (t: Tab) => {
      switch (t) {
        case Tab.channel:
          return location.pathname.includes("channel");
        case Tab.categories:
          return location.pathname.includes("source-categories");
        case Tab.buckets:
          return location.pathname.includes("bucket");
        case Tab.consolidate:
          return location.pathname.includes("consolidate");
        case Tab.audit:
          return location.pathname.includes("audit");

        default:
          return false;
      }
    },
    [location]
  );

  return (
    <>
      <TabContainer fullWidth>
        {enumToArray(Tab).map((t) => (
          <TabButton
            key={t}
            onClick={() => onTabChange(t)}
            isActive={isActive(t)}
          >
            {t}
          </TabButton>
        ))}
      </TabContainer>
      <Box mt={4}>
        <Switch>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/channels"
          >
            <ChannelsPage />
          </Route>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/source-categories"
          >
            <SourcCategoriesPage title="Source Categories" />
          </Route>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/buckets"
          >
            <TrafficBucketsPage />
          </Route>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/buckets/:bucketId"
          >
            <TrafficBucketPage />
          </Route>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/consolidate"
          >
            <TrafficConsolidatePage />
          </Route>
          <Route
            exact
            path="/clients/:clientId/projects/:projectId/train/traffic/audit"
          >
            <TrafficAuditPage title="Traffic Audit" />
          </Route>
        </Switch>
      </Box>
    </>
  );
}

export default TrafficPage;
